import styled, { keyframes } from 'styled-components'

export type SkeletonProps = {
  width?: string
  height?: string
  radial?: boolean
}

const shimmer = keyframes`
    100% {
      transform: translateX(100%);
    }
  `

export const Skeleton = styled.div<SkeletonProps>`
  display: inline-block;
  width: ${props => props.width || '100px'};
  height: ${props => props.height || '1em'};
  position: relative;
  overflow: hidden;
  background-color: #dddbdd;
  border-radius: ${props => (props.radial ? '50%' : '4px')};

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${shimmer} 1s infinite;
    content: '';
  }
`
